import { useLayoutEffect, useRef } from 'react';
export const usePromptHistory = (value, onChange)=>{
    const entries = useRef([]);
    const cursor = useRef(null);
    const inProgressDraft = useRef('');
    const inputElement = useRef(null);
    const pendingCaret = useRef(null);
    const currentValue = value !== null && value !== void 0 ? value : '';
    useLayoutEffect(()=>{
        const element = inputElement.current;
        if (element == null || pendingCaret.current == null) return;
        const position = pendingCaret.current === 'start' ? 0 : element.value.length;
        element.setSelectionRange(position, position);
        pendingCaret.current = null;
    });
    const recordSubmission = ()=>{
        if (currentValue.trim().length > 0) entries.current = [
            ...entries.current,
            currentValue
        ];
        cursor.current = null;
        inProgressDraft.current = '';
    };
    const recallPrevious = (input)=>{
        const history = entries.current;
        if (history.length === 0) return false;
        if (cursor.current == null) {
            inProgressDraft.current = currentValue;
            cursor.current = history.length - 1;
        } else if (cursor.current > 0) {
            cursor.current -= 1;
        } else {
            return true;
        }
        inputElement.current = input;
        pendingCaret.current = 'start';
        onChange(history[cursor.current]);
        return true;
    };
    const recallNext = (input)=>{
        if (cursor.current == null) return false;
        const history = entries.current;
        inputElement.current = input;
        pendingCaret.current = 'end';
        if (cursor.current < history.length - 1) {
            cursor.current += 1;
            onChange(history[cursor.current]);
        } else {
            cursor.current = null;
            onChange(inProgressDraft.current);
        }
        return true;
    };
    return {
        recordSubmission,
        recallPrevious,
        recallNext
    };
};
